import {request} from "./APIUtils";
import Alert from "react-s-alert";
import axios from "axios/index";
import {showBarStandartVouchers, showConnector, showInvoiceTotalFilter, showPredefinedBtn} from "./permission";
import {EntegratorConf, VirtualHost} from "../constants";
import {CustomerBankType, EntegratorIdentifiers, UserRightsEnum} from "./enums";
import {value} from "lodash/seq";
import React from "react";

export function deepCopyObject(oldObject) {
    return JSON.parse(JSON.stringify(oldObject));
}

export function showAxiosError(error,position) {
    if (error.response) {
        let response = error.response;
        if (typeof response.data === 'string') {
            Alert.error(response.data, {
                position: position || 'top-right',
                effect: 'stackslide',
                timeout: 7000,
                html:false
            });
        } else if (response.data instanceof ArrayBuffer) {
            let decodedText = new TextDecoder("utf-8").decode(response.data);
            Alert.error(decodedText, {
                position: position || 'top-right',
                effect: 'stackslide',
                timeout: 7000,
                html:false
            });
        } else if (error.response.status === 401) {
            Alert.error('Bu işlemi yapmaya yetkiniz yok. Yeniden giriş yapmayı deneyin.', {
                position: position || 'top-right',
                effect: 'stackslide',
                timeout: 7000,
                html:false
            });
        } else if (typeof response.data === 'object' && Array.isArray(response.data.errors)) {
            let message = "";
            response.data.errors.map(m => message += "<strong>" + m + "</strong><br/>")
            Alert.error(message, {
                position: position || 'top-right',
                effect: 'stackslide',
                timeout: 7000,
                html:false
            });
        }  else {
            let message = "İşleminiz şuan gerçekleştirilemiyor...";
            if (response.data.Error) {
                message = response.data.Error;
            } else if (response.data.Exception) {
                message = response.data.Exception;
            } else {
                console.error(response.data);
            }

            Alert.error(message, {
                position: position || 'top-right',
                effect: 'stackslide',
                timeout: 7000,
                html:false
            });
        }
    } else if (error.request) {
        console.log(error.request);
    } else if (error.Error) {
        Alert.error(error.Error, {
            position: position || 'top-right',
            effect: 'stackslide',
            timeout: 7000,
            html:false
        });
    } else if (axios.isCancel(error)) {
        if (!!error.message)
            console.log('cancelled:', error.message);
    } else {
        console.log('Error', error);
        Alert.error(error.message, {
            position: position || 'top-right',
            effect: 'stackslide',
            timeout: 7000,
            html:false
        });
    }
}

export async function getStocks(key, from) {
    if (!key) {
        return Promise.resolve({options: []});
    } else {
        let options = [];
        let isFromItemCode = from === "itemCode";
        if ((!isFromItemCode && key.length >= 1) || (isFromItemCode && key.length >= 3)) {
            let params = {
                url: isFromItemCode ? '/stock/searchStockByCode' : `/stock/searchStockByName`,
                method: "post",
                data: key
            };
            await request(params)
                .then(response => {
                    let stocks = response.data;
                    return options = stocks.map(stock => ({
                        value: isFromItemCode ? stock.code : stock.name,
                        label: stock.name,
                        stock: stock
                    }));
                }).catch(function (error) {
                    showAxiosError(error);
                });

            if (VirtualHost.conf.resourcePrefix === "eczacikart") {
                let notIncludedList = [];
                options.map(option => {
                    if (option && option.stock && option.stock.code !== "" && option.stock.code !== undefined && option.stock.code !== null) {
                        notIncludedList.push(option.stock.code);
                    }
                });

                let flag = false;
                if (isFromItemCode) {
                    params = {
                        url: '/chemistStock/searchStockByCode',
                        method: "post",
                        data: {
                            'searchKey': key,
                            'notIncludedList': notIncludedList
                        }
                    };
                    flag = true;
                } else if (!isFromItemCode && key.length >= 3) {
                    params = {
                        url: '/chemistStock/searchStockByName',
                        method: "post",
                        data: {
                            'searchKey': key,
                            'notIncludedList': notIncludedList
                        }
                    };
                    flag = true;
                }

                if (flag) {
                    await request(params)
                        .then(response => {
                            let stocks = response.data;
                            let optionsChemist = stocks.map(stock => ({
                                value: isFromItemCode ? stock.code : stock.name,
                                label: stock.name,
                                stock: stock
                            }));
                            options = options.concat(optionsChemist);
                        })
                        .catch(function (error) {
                            showAxiosError(error);
                        });
                }
            } else if (["avho", "veteriner"].includes(VirtualHost.conf.resourcePrefix)) {
                let notIncludedList = [];
                options.map(option => {
                    if (option && option.stock && option.stock.name !== "" && option.stock.name !== undefined && option.stock.name !== null) {
                        notIncludedList.push(option.stock.name);
                    }
                });

                let flag = false;
                if (!isFromItemCode) {
                    params = {
                        url: '/veterinarianStock/searchStockByName',
                        method: "post",
                        data: {
                            'searchKey': key,
                            'notIncludedList': notIncludedList
                        }
                    };

                    flag = true;
                }

                if (flag) {
                    await request(params)
                        .then(response => {
                            let stocks = response.data;
                            let optionsChemist = stocks.map(stock => ({
                                value: stock.name,
                                label: stock.name,
                                stock: stock
                            }));
                            options = options.concat(optionsChemist);
                        })
                        .catch(function (error) {
                            showAxiosError(error);
                        });
                }
            }

            return {options}
        } else {
            return Promise.resolve({options: []});
        }
    }
}

export function readStock(key) {
    if (!key) {
        return Promise.resolve({options: []});
    } else {
        if (key.length >= 1) {
            let params = {
                url: `/connector/readStock`,
                method: "post",
                data: key
            };
            return request(params)
                .then(response => {
                    let stocks = response.data;
                    let options = stocks.map(stock => ({
                        value: stock.itemName,
                        label: stock.itemName,
                        stock: stock
                    }));
                    return {options};
                })
                .catch(function (error) {
                    showAxiosError(error);
                });
        } else {
            return Promise.resolve({options: []});
        }
    }
}

export async function listStocksFromVoucherModal(stoppagePercentage, kdvSell) {

    let extraItems=["İlam Vekalet Ücreti", "Vekalet Ücreti", "Avukatlık Ücreti", "İcra Vekalet Ücreti", "Arabuluculuk Ücreti", "Hukuki Danışmanlık Ücreti"];
    let defaultOptions=[];
    let result=[];
    let params = {
        url: `/stock/listStocks`,
        method: "post",
    };
    return request(params)
        .then(response => {
            let stocks = response.data;
            let options = stocks.map(stock => ({
                value: stock.name,
                label: stock.name,
                stock: stock
            }));
            if (showBarStandartVouchers()) {
                for (const item of extraItems) {
                    let contains = false;
                    for (const option of options) {
                        if (option.value.toString().toLocaleLowerCase() === item.toString().toLocaleLowerCase()) {
                            contains = true;
                            break;
                        }
                    }
                    if (contains === false) {
                        defaultOptions.push(
                            {
                                value: item,
                                label: item,
                                stock: {
                                    alias: "",
                                    baseUnit: "C62",
                                    code: "",
                                    defPricePurchase: 0,
                                    defPriceSell: 0,
                                    defaultCurrencyCode: "TRY",
                                    explanation: "",
                                    itemType: {recordId: 2, itemName: "HİZMET"},
                                    kdvPurchase: 0,
                                    kdvSell: kdvSell,
                                    gvStoppagePurchase: 0,
                                    gvStoppageSell: stoppagePercentage,
                                    name: item,
                                    otv: 0,
                                    recordId: null,
                                    stockGroup: 1,
                                }
                            });
                    }
                }
            }
            result = (showBarStandartVouchers() ? defaultOptions.concat(options) : options);
            return {result};
        })
        .catch(function (error) {
            showAxiosError(error);
        });

}

export function getExternalCustomers(key, checkGibUser, type, docType) {
    console.log("checkGibUSer", checkGibUser)
    if (!key) {
        return Promise.resolve({options: []});
    } else {
        if (key.length >= 3) {
            let params = {
                url: `/externalCustomer/externalCustomers`,
                method: "post",
                data: {
                    checkGibUser: (checkGibUser ? checkGibUser : false),
                    searchKey: key,
                    type: type,
                }
            };
            return request(params)
                .then(response => {
                    let externalCustomers = response.data;
                    let options = [];
                    if(response.data.length > 0){
                        if( docType && ['EARSIVFATURA', 'EFATURA'].includes(docType)){
                            options = externalCustomers.map(externalCustomer => ({
                                value: JSON.stringify(externalCustomer),
                                label: (externalCustomer.vknTckn + "-"
                                    + (externalCustomer.title || externalCustomer.formattedName || (externalCustomer.givenName + " " + externalCustomer.familyName))) + " - " +
                                    (externalCustomer.hasPostboxAlias || externalCustomer.externalCustomerAddressList.filter(item => (item.postboxAlias !== null && item.postboxAlias !== "")).length > 0 ? "EFATURA" : "EARŞİV")
                            }));

                        }else{
                            options = externalCustomers.map(externalCustomer => ({
                                value: JSON.stringify(externalCustomer),
                                label: (externalCustomer.vknTckn + "-"
                                    + (externalCustomer.title || externalCustomer.formattedName || (externalCustomer.givenName + " " + externalCustomer.familyName)))
                            }));
                        }
                    }else{
                        if(docType && ['EARSIVFATURA', 'EFATURA'].includes(docType) && showPredefinedBtn() && (key.length === 10 || key.length === 11)){
                            options = [{
                                value: JSON.stringify(newExternalCustomer(key)),
                                label: key +' nolu vkn/tckn için e-Arşiv Fatura oluştur.'
                            }];
                        }
                    }

                    return {options};
                })
                .catch(function (error) {
                    showAxiosError(error);
                });
        } else {
            return Promise.resolve({options: []});
        }
    }
}

function newExternalCustomer(vkn){
    return {
        commerceChamber: null,
        customer: null,
        familyName: "",
        formattedName: "",
        givenName: "",
        mersisNumber: "",
        middleName: "",
        recordId: null,
        taxOffice: "",
        title: "",
        tradeRegistrationNumber: "",
        vknTckn: vkn,
        externalCustomerAddressList: [],
    };
}


export function exportXls(payload) {
    let params = {
        url: payload.url, //TODO: self
        method: "post",
        responseType: 'arraybuffer',
        data: payload.data
    };
    request(params).then(function (response) {
        let blob = new Blob([response.data], {type: response.headers["content-type"]});
        let urlCreator = window.URL || window.webkitURL;
        let url = urlCreator.createObjectURL(blob);
        let a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = payload.data.sheetName + ".xls";
        a.click();
    }).catch(function (error) {
        showAxiosError(error);
    });
}

export function getNaceCodes(key) {
    if (!key) {
        return Promise.resolve({options: []});
    } else {
        if (key.length >= 1) {
            let params = {
                url: `/customer/naceCodes`,
                method: "post",
                data: {
                    searchKey: key,
                    type: "naceCode"
                }
            };
            return request(params)
                .then(response => {
                    let naceCodes = response.data;
                    let options = naceCodes.map(naceCode => ({
                        value: naceCode.id,
                        label: naceCode.code + ' , ' + naceCode.description,
                        description: naceCode.description,
                        customValue: naceCode.code
                    }));
                    return {options};
                })
                .catch(function (error) {
                    showAxiosError(error);
                });
        } else {
            return Promise.resolve({options: []});
        }
    }
}

export function getCustomersNative(key) {
    let _source = axios.CancelToken.source();
    if (!key) {
        return Promise.resolve({options: []});
    } else {
        if (key.length >= 3) {
            let params = {
                url: `/customer/listCustomersNative`,
                method: "post",
                cancelToken: _source.token,
                data: {searchKey: key}
            };
            return request(params)
                .then(response => {
                    let customers = response.data;
                    let options = customers.map(customer => ({
                        value: JSON.stringify(customer),
                        label: (customer.vknTckn + "-" + customer.formattedName)
                    }));
                    return {options};
                })
                .catch(function (error) {
                    showAxiosError(error);
                });
        } else {
            return Promise.resolve({options: []});
        }
    }
}

export function getForeignCompanyInfo(key,type) {
    if (!key) {
        return Promise.resolve({options: []});
    } else {
        if (key.length >= 1) {
            let params = {
                url: `/externalCustomer/externalCustomers`,
                method: "post",
                data: {
                    searchKey: key,
                    type: type ? "includeForeign" : "foreignCompany"
                }
            };
            return request(params)
                .then(response => {
                    let externalCustomers = response.data;
                    let options = externalCustomers.map(externalCustomer => ({
                        value: JSON.stringify(externalCustomer),
                        label: (externalCustomer.title || externalCustomer.formattedName || (externalCustomer.givenName + " " + externalCustomer.familyName)) +(externalCustomer.vknTckn ? "("+externalCustomer.vknTckn+")":"")
                    }));
                    return {options};
                })
                .catch(function (error) {
                    showAxiosError(error);
                });
        } else {
            return Promise.resolve({options: []});
        }
    }
}

export async function fetchAllPkList(vknTckns) {
    let pkList=[];
    if (vknTckns) {
        let params = {
            url: '/externalCustomer/fetchAllPkList',
            data: vknTckns,
            method: 'post'
        };
        return request(params).then((response) => {
            if (response.data) {
                pkList = response.data;
            }
            return Promise.resolve(pkList);
        }).catch(function (error) {
            showAxiosError(error);
            return Promise.resolve(null);
        });
    }
}

export async function checkDuplicateTcknVkns(vknTcknArr) {
    let params = {
        url: `/externalCustomer/findByVknTcknsExists`,
        method: "post",
        data: vknTcknArr
    };
    return request(params)
        .then(response => {
            let controlList = response.data;
            return Promise.resolve(controlList);
        })
        .catch(function (error) {
            showAxiosError(error);
            return Promise.resolve([]);
        });
}

export function findNested(obj, expression) {
    return findElement(obj, expression.split(/\./));
}

export function assignNested(obj, expression, newValue) {
    return replaceElement(obj, expression.split(/\./), newValue);
}

export function showNotification(thisObj, message, type = 'success', seconds = 3, icon = 'now-ui-icons ui-1_bell-53') {
    thisObj.refs.notificationAlert.notificationAlert({
        place: 'tr',
        message: message,
        type: type,
        icon: icon,
        autoDismiss: seconds
    });
}

function findElement(obj, tokens) {
    if (tokens.length === 0) {
        return obj === undefined ? null : obj;
    }
    return findElement(obj[tokens.shift()], tokens);
}

function replaceElement(data, tokens, newValue) {

    if (!Array.isArray(tokens) || tokens.length === 0) {
        return false;
    }
    if (tokens.length === 1) {
        if (data[tokens[0]] !== undefined) {
            data[tokens[0]] = newValue;
            return true;
        } else
            return false;
    }
    return replaceElement(data[tokens.shift()], tokens, newValue);
}

export function monthName(monthNumber) {
    switch (monthNumber) {
        case 1 :
            return "Ocak";
        case 2 :
            return "Şubat";
        case 3 :
            return "Mart";
        case 4 :
            return "Nisan";
        case 5 :
            return "Mayıs";
        case 6 :
            return "Haziran";
        case 7 :
            return "Temmuz";
        case 8 :
            return "Ağustos";
        case 9 :
            return "Eylül";
        case 10 :
            return "Ekim";
        case 11 :
            return "Kasım";
        case 12 :
            return "Aralık";
        default:
            return "Geçersiz değer."
    }
}

export function prefixTypeName(type) {
    switch (type) {
        case "PrefixCode" :
            return "E-Fatura";
        case "EArsivPrefixCode" :
            return "E-Arşiv";
        case "DespatchPrefixCode" :
            return "E-İrsaliye";
        case "MVoucherPrefixCode" :
            return "Müstahsil Makbuzu";
        case "SVoucherPrefixCode" :
            return "Serbest Meslek Makbuzu";
        case "ExchangePrefixCode" :
            return "E-Döviz Belgeleri";
        case "ReceiptAdvicePrefixCode" :
            return "E-İrsaliye Yanıtı";
        case "ExpenseNotePrefixCode" :
            return "E-Gider Pusulası";
        case "ReceiptPrefixCode" :
            return "E-Adisyon Makbuzu";
        case "SigortaPrefixCode" :
            return "E-Sigorta";
        default:
            return "Geçersiz tip."
    }
}

export function humanReadableByteCount(bytes, si) {
    var thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }
    var units = si
        ? ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    var u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1) + ' ' + units[u];
}
export function humanReadableByteCount2(bytes) {
    var thresh = 1024;
    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }
    var units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    var u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1) + ' ' + units[u];
}

export function xsltTypeLabel(type) {

    switch (type) {
        case 1:
        case 'EARSIV':
            return 'E-Arşiv';
        case 2:
        case 'EFATURA':
            return 'E-Fatura';
        case 3:
        case 'EDEFTER_YEVMIYE':
            return 'E-Defter Yevmiye';
        case 4:
        case 'EDEFTER_KEBIR':
            return 'E-Defter Kebir';
        case 5:
        case 'EDEFTER_BERAT':
            return 'E-Defter Berat';
        case 6:
        case 'EIRSALIYE':
            return 'E-İrsaliye';
        case 7:
        case 'ESMM':
            return 'E-Serbest Meslek Mak.';
        case 8:
        case 'EMM':
            return 'E-Müstahsil Mak.';
        case 11:
        case 'EDOVIZ':
            return 'E-Döviz';
        case 122:
        case 'EGIDERPUSULASI':
            return 'E-Gider Pusulası';
        case 124:
        case 'EARSIVBESBINOTUZBIN':
            return 'e-Arşiv 5000/3000';
        default:
            return '-';
    }
}

export function xsltEnumToInt(enumVal) {

    switch (enumVal) {
        case 'EARSIV':
            return 1;
        case 'EFATURA':
            return 2;
        case 'EDEFTER_YEVMIYE':
            return 3;
        case 'EDEFTER_KEBIR':
            return 4;
        case 'EDEFTER_BERAT':
            return 5;
        case 'EIRSALIYE':
            return 6;
        case 'ESMM':
            return 7;
        case 'EMM':
            return 8;
        case 'EDOVIZ':
            return 11;
        case 'EIRSALIYE_YANITI':
            return 66;
        case 'EGIDERPUSULASI':
            return 122;
        case 'EARSIVBESBINOTUZBIN':
            return 124;
        case 'ERECEIPT':
            return 12;
        case 'ESIGORTA':
            return 125;
        default:
            return null;
    }
}

export function xsltTypeList() {
    return [1, 2, 3, 4, 5, 6, 7, 8, 11, 66, 122, 125];
}

export const xsltTypeMap=[
    {value:null,label:'Tümü'},
    {value:1,label:'E-Arsiv'},
    {value:2,label:'E-Fatura'},
    {value:3,label:'E-Defter Yevmiye'},
    {value:4,label:'E-Defter Kebir'},
    {value:5,label:'E-Defter Berat'},
    {value:6,label:'E-İrsaliye'},
    {value:7,label:'E-Serbest Meslek Mak.'},
    {value:8,label:'E-Müstahsil Mak.'},
    {value:11,label:'E-Döviz'},
    {value:66,label:'E-İrsaliye Yanıtı'},
    {value:122,label:'E-Gider Pusulası'},
    {value:124,label:'E-Arşiv 5000/3000'},
    {value:12,label:'E-Adisyon'},
    {value:125,label:'E-Sigorta'},
];

export function invoiceTypesSelectData() {
    return [
        {value: null, label: 'Tümü'},
        {value: 'SATIS', label: 'Satış'},
        {value: 'IADE', label: 'İade'},
        {value: 'ISTISNA', label: 'İstisna'},
        {value: 'TEVKIFAT', label: 'Tevkifat'},
        {value: 'OZELMATRAH', label: 'Özel Matrah'},
        {value: 'IHRACKAYITLI', label: 'İhraç Kayıtlı'},
        {value: 'SGK', label: 'SGK'},
        {value: 'KOMISYONCU', label: 'Komisyoncu'},
        {value: 'KONAKLAMAVERGISI', label: 'Konaklama Vergisi'},
    ]
}

export function eArchieveInvoiceTypesSelectData() {
    return [
        {value: null, label: 'Tümü'},
        {value: 'SATIS', label: 'Satış'},
        {value: 'IADE', label: 'İade'},
        {value: 'TEVKIFAT', label: 'Tevkifat'},
        {value: 'ISTISNA', label: 'İstisna'},
        {value: 'OZELMATRAH', label: 'Özel Matrah'},
        {value: 'IHRACKAYITLI', label: 'İhraç Kayıtlı'},
        {value: 'HKSSATIS', label: 'Hal Tipi Fatura Satış'},
        {value: 'KOMISYONCU', label: 'Komisyoncu'},
        {value: 'HKSKOMISYONCU', label: 'Hal Tipi Fatura Komisyoncu'},
        {value: 'TEVKIFATIADE', label: 'Tevkifat İade'},
        {value: 'KONAKLAMAVERGISI', label: 'Konaklama Vergisi'},
        {value: 'SARJ', label: 'Şarj'},
        {value: 'SARJANLIK', label: 'Şarj Anlık'},
        {value: 'TEKNOLOJIDESTEK', label: 'Teknoloji Destek'},
    ]
}

export function despatchTypesSelectData() {
    return [
        {value: null, label: 'Tümü'},
        { value: 'TEMELIRSALIYE', label: 'TEMEL İRSALİYE' },
        { value: 'HALTIPI', label: 'HAL TİPİ' },
        { value: 'HKSIRSALIYE', label: 'HKS İRSALİYE' }

    ]
}

export function despatchProfileTypesSelectData() {
    return [
        {value: null, label: 'Tümü'},
        {value: 'SEVK', label: 'Sevk'},
        {value: 'MATBUDAN', label: 'Matbudan'},
    ]
}

export function invoiceProfileTypesSelectData() {
    return [
        {value: null, label: 'Tümü'},
        {value: 'TEMELFATURA', label: 'Temel Fatura'},
        {value: 'TICARIFATURA', label: 'Ticari Fatura'},
        {value: 'IHRACAT', label: 'İhracat Fatura'},
        {value: 'YOLCUBERABERFATURA', label: 'Yolcu Beraber Fatura'},
        {value: 'HKS', label: 'Hal Tipi Fatura'},
        {value: 'KAMU', label: 'Kamu Tipi Fatura'},
        {value: 'ENERJI', label: 'Enerji'},
    ]
}

export function defterControlProfile() {
    return [
        {value: null, label: 'Tümü'},
        {value: '1', label: 'Kebir'},
        {value: '2', label: 'Yevmiye'},
    ]
}

export function defterControlDefterTypes() {
    return [
        {value: 'ALL', label: 'Tümü'},
        {value: 'KEBIR', label: 'Kebir'},
        {value: 'YEVMIYE', label: 'Yevmiye'},
    ]
}

export function defterControlProgress() {
    return [
        {value: null, label: 'Tümü'},
        {value: 'WAITING', label: 'Kuyrukta'},
        {value: 'IN_PROGRESS', label: 'İşleniyor'},
        {value: 'FINISHED', label: 'Bitti'},
    ]
}

export function defterControlEvaluationResult() {
    return [
        {value: null, label: 'Tümü'},
        {value: 'FAILURE', label: 'Hatalı'},
        {value: 'SUCCESS', label: 'Başarılı'}
    ]
}

export function defterControlTransactionCodes() {
    return [
        {value: null, label: 'Tümü'},
        {value: 'DEBIT', label: 'BORÇ'},
        {value: 'CREDIT', label: 'ALACAK'}
    ]
}

export function selectServiceData() {
    let services = [
        {value: '1', label: 'E-Arsiv'},
        {value: '2', label: 'E-Fatura'},
        {value: '3', label: 'E-Defter'},
        {value: '5', label: 'E-Defter Saklama'},
        {value: '6', label: 'E-İrsaliye'},
        {value: '7', label: 'SMM'},
        {value: '8', label: 'MM'},
        {value: '11', label: 'E-Döviz'},
        {value: '88', label: 'Defter Kontrol'},
        {value: '121', label: 'E-Defter İkincil Kopya'},
        {value: '122', label: 'E-Gider Pusulası'},
        // {value: '125', label: 'E-Sigorta'}
    ];

    if ([EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(EntegratorConf.identifier)) {
        services.push({value: '124', label: 'E-Arşiv 5000-30000'})
    }

    return services;
}

export function filterServices(xsltTypeMap,userServices){
    const filteredServices=[];
    //filteredServices.push({value:null,label:'Tümü'});
    if(xsltTypeMap && userServices) {
        for (const service of xsltTypeMap) {
            for (const userService of userServices) {
                if(service.value===userService){
                    filteredServices.push({
                        value: service.value,
                        label: service.label
                    })
                    /* if(service.value===6)
                     {
                         filteredServices.push({
                             value:66,
                             label:'E-İrsaliye Yanıtı'
                         })
                     }*/
                    break;
                }
            }
        }
    }

    return filteredServices;
}

export function findByValue(xsltTypeMap,value){
    for (const xsltType of xsltTypeMap) {
        if(xsltType.value===value){
            return xsltType;
        }
    }
    return {
        value:0,
        label:''
    }
}

export function  aliasSelectData(alias){
    let arrayData =[{value: null, label: 'Tümü'}];
    for(let index in alias){
        arrayData.push({value:alias[index], label:alias[index]});
    }
    return arrayData;
}

export function appResponses() {
    return [
        {value: null, label: 'Tümü'},
        {value: 'KABUL', label: 'Kabul'},
        {value: 'RED', label: 'Red'},
        {value: 'NOTRED', label: 'Red Cevabı Verilmeyenler'}
    ]
}

export function AppResponseSelectData() {
    return [
        {value: null, label: 'Tümü'},
        {value: 'NOTRESPONDED', label: 'Cevap Verilmedi'},
        {value: 'ACCEPT', label: 'Kabul'},
        {value: 'REJECT', label: 'Red'},
        {value: 'INVALID', label: 'Geçersiz Cevap'}
    ]
}

export function DespatchResponseSelectData(){
    return[
        {value: null, label: 'Tümü'},
        {value: 'RESPONDED', label: 'Cevaplananlar'},
        {value: 'NOTRESPONDED', label: 'Cevaplanmayanlar'},
        {value: 'INVALID', label: 'Geçersiz Cevap'},
        {value: 'AUTOACCEPT', label: 'Otomatik Kabul'}
    ]
}

export function DespatchStateData(){
    return[
        {value: null, label: "Tümü"},
        {value: "1", label: "Hatasız"},
        {value: "3", label: "Hatalı"},
        {value:"1000", label:"(1000) ZARF GİB'E GÖNDERİLDİ"},
        {value:"1100", label:"(1100) ZARF İŞLENİYOR"},
        {value:"1120", label:"(1120) ZARF ID UZUNLUGU GECERSİZ"},
        {value:"1130", label:"(1130) ZIP ACILAMADI"},
        {value:"1150", label:"(1150) SCHEMATRON KONTROL SONUCU HATALI"},
        {value:"1160", label:"(1160) XML SEMA KONTROLUNDEN GECEMEDİ"},
        {value:"1163", label:"(1163) GONDERİLEN ZARF SİSTEMDE DAHA ONCE KAYITLI OLAN BIR FATURAYI İCERMEKTEDİR"},
        {value:"1164", label:"(1164) SİSTEM HATASI(GIB)"},
        {value:"1170", label:"(1170) YETKİ KONTROL EDİLEMEDİ"},
        {value:"1171", label:"(1171) GONDERİCİ BİRİM YETKİSİ YOK"},
        {value:"1172", label:"(1172) POSTA KUTUSU YETKİSİ YOK"},
        {value:"1173", label:"(1173) İRSALİYE İŞLEM YETKİSİ YOK"},
        {value:"1180", label:"(1180) ADRES KONTROL EDİLEMEDİ"},
        {value:"1181", label:"(1181) ADRES BULUNAMADİ"},
        {value:"1195", label:"(1195) SİSTEM HATASI"},
        {value:"1200", label:"(1200) ZARF BASARIYLA İŞLENDİ"},
        {value:"1215", label:"(1215) DOKÜMAN GONDERİMİ BAŞARISIZ. TEKRAR GÖNDERME SONLANDI"},
        {value:"1220", label:"(1220) HEDEFTEN SİSTEM YANITI GELMEDİ"},
        {value:"1230", label:"(1230) HEDEFTEN SİSTEM YANITI BAŞARISIZ GELDİ"},
        {value:"1300", label:"(1300) BAŞARIYLA TAMAMLANDI"},
    ]
}

export function invoiceStateData(){
    return[
        {value: null, label: "Tümü"},
        {value: "1", label: "Hatasız"},
        {value: "3", label: "Hatalı"},
        {value: "13", label: "(13) FATURA GÖNDERİM İPTALİ"},
        {value:"1000", label:"(1000) ZARF GİB'E GÖNDERİLDİ"},
        {value:"1100", label:"(1100) ZARF İŞLENİYOR"},
        {value:"1120", label:"(1120) ZARF ID UZUNLUGU GECERSİZ"},
        {value:"1130", label:"(1130) ZIP ACILAMADI"},
        {value:"1150", label:"(1150) SCHEMATRON KONTROL SONUCU HATALI"},
        {value:"1160", label:"(1160) XML SEMA KONTROLUNDEN GECEMEDİ"},
        {value:"1163", label:"(1163) GONDERİLEN ZARF SİSTEMDE DAHA ONCE KAYITLI OLAN BIR FATURAYI İCERMEKTEDİR"},
        {value:"1164", label:"(1164) SİSTEM HATASI(GIB)"},
        {value:"1170", label:"(1170) YETKİ KONTROL EDİLEMEDİ"},
        {value:"1171", label:"(1171) GONDERİCİ BİRİM YETKİSİ YOK"},
        {value:"1172", label:"(1172) POSTA KUTUSU YETKİSİ YOK"},
        {value:"1180", label:"(1180) ADRES KONTROL EDİLEMEDİ"},
        {value:"1181", label:"(1181) ADRES BULUNAMADİ"},
        {value:"1195", label:"(1195) SİSTEM HATASI"},
        {value:"1200", label:"(1200) ZARF BASARIYLA İŞLENDİ"},
        {value:"1215", label:"(1215) DOKÜMAN GONDERİMİ BAŞARISIZ. TEKRAR GÖNDERME SONLANDI"},
        {value:"1220", label:"(1220) HEDEFTEN SİSTEM YANITI GELMEDİ"},
        {value:"1230", label:"(1230) HEDEFTEN SİSTEM YANITI BAŞARISIZ GELDİ"},
        {value:"1300", label:"(1300) BAŞARIYLA TAMAMLANDI"},
    ]
}

export function reportStateData(){
    return[
        {value: null, label: "Tümü"},
        {value: "0", label: "(0) GİB'e gönderildi"},
        {value: "1", label: "(1) Rapor işleniyor"},
        {value: "10", label: "(10) Dosya kuyrukta(GİB)"},
        {value:"15", label:"(15) Paket işlenmeye başlandı(GİB)"},
        {value:"30", label:"(30) Paket başarıyla işlendi(GİB)"},
        {value:"151", label:"(151) Dosya DFS'ten okunamadı"},
        {value:"167", label:"(167) İmza sahibi ile hazırlayan VKN/TCKN uyuşmuyor"},
        {value:"168", label:"(168) Göndericinin bu mükellefin raporunu işletme yetkisi yok."}
        ]
}

export function invoiceStates() {

    return [
        {value: null, label: "Tümü"},
        {value: "1", label: "Hatasız"},
        {value: "3", label: "Hatalı"},
    ]
}

export function cancelledStates() {
    return [
        {value: null, label: "Tümü"},
        {value: "0", label: "İptal Edilmeyenler"},
        {value: "1", label: "İptal Edilenler"},
    ]
}

export function cancelPortalStatus() {
    return [
        {value: null, label: "Tümü"},
        {value: "0", label: "İptal Edilmeyenler"},
        {value: "1", label: "İptal Edilenler"},
    ]
}

export function isGursut(vknTckn) {
    // Gürsüt, Gürtepe, Progıda olduğunda filtre de fatura gönderen yazacak.

    let vknTcknList = ['4490487238', '7331005169', '4390358469'];
    return vknTcknList.includes(vknTckn);

}

export function readingStatus() {
    return [
        {value: null, label: "Tümü"},
        {value: "0", label: "Okunmadı"},
        {value: "1", label: "Okundu"},
    ]
}

export function archiveStatus() {
    return [
        {value: null, label: "Tümü"},
        {value: "1", label: "Arşivlenenler"},
        {value: "0", label: "Arşivlenmeyenler"},
    ]
}

export function copyTextToClipboard(textToCopy) {
    let textArea = document.createElement("textarea");

    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;

    textArea.style.width = '2em';
    textArea.style.height = '2em';

    textArea.style.padding = 0;

    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';

    textArea.style.background = 'transparent';

    textArea.value = textToCopy;

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    let successful = false;
    try {
        successful = document.execCommand('copy');
    } catch (err) {
        console.error("Kopyalama başarısız:" + err);
        successful = false;
    }

    document.body.removeChild(textArea);
    return successful;
}

export function getFilenameFromResponse(response) {
    if (!response) return null;
    if (!response.headers) return null;
    if (!response.headers["content-disposition"]) return null;

    let header = response.headers["content-disposition"];

    let startIndex = header.indexOf("filename=");

    if (startIndex === -1)
        return null;

    let endIndex = header.length;
    return header.substring(startIndex + 9, endIndex);

}

export function formattedNumber(number, locale = "tr-TR") {
    return new Intl.NumberFormat(locale).format(number);
}

//gelen sayıyı binlik kısmı "." ondalık kısmı "," ile ayırır
export function changeNumberFormat(number,locale = "tr-TR"){
    if(number != null && number != "" && number != 0){
    return new Intl.NumberFormat(locale,{
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(number);
    }else return "0,00";
}

export function getYearsList() {
    let date = new Date();
    let years = []
    for(let i = date.getFullYear(); i >= 2016; i--){
        years.push({value:i,label:i});
    }
    return years;
}

export function getYearsListWithMinYear(minYear) {
    let date = new Date();
    let years = []
    for(let i = date.getFullYear(); i >= minYear; i--){
        years.push({value:i,label:i});
    }
    return years;
}

export function getDateTypeList(){
    return [
        {value: 'today', label:'Bugün'},
        {value: 'week', label:'Son 7 Gün'},
        {value: 'month', label:'Son 30 Gün'}
    ]
}

export function getReferenceIdList(flag){
    return flag ? [
            {label:"Tümü",value:null},
            {label:"PORTAL",value:"0"},
            {label:"ERP",value:"1"}
        ]:[{label:"Tümü",value:null}];

}

export function ibanExistsInPaymentArray(arr, text) {
    let exists=false;
    if(arr==null || text==null || text==='') {
        return  exists;
    }
    else{
        for(var i=0;i<arr.length;i++)
        {
            if(arr[i].iban===text){
                exists=true;
                break;
            }
        }
        return exists;
    }
}

export function toFixedNumber(num, digits, base){
    var pow = Math.pow(base||10, digits);
    return Math.round(num*pow) / pow;
}

export function hasUserRight(title, currentUser) {
    if (Array.isArray(title)) {
        return currentUser && currentUser.userRights && currentUser.userRights.filter(item => title.includes(item)).length > 0;
    } else {
        return currentUser && currentUser.userRights && currentUser.userRights.includes(title);
    }
}

export async function getEntegratorConf() {
    let entegratorConf = EntegratorConf;
    if (Object.keys(entegratorConf).length > 0) {
        return entegratorConf;
    }

    let params = {
        url: `/common/getEntegratorConf`,
        method: "get"
    };

    entegratorConf = await request(params).then(function (response) {
        entegratorConf = response.data;
        Object.assign(EntegratorConf, entegratorConf);
        return entegratorConf;
    }).catch(function (error) {
        showAxiosError(error);
    });

    return entegratorConf;
}

export function trimObject(obj){
    Object.keys(obj).map(k => obj[k] = typeof obj[k] === 'string' ? obj[k].trim() : obj[k]);
    return obj;
}

export function setFields(fields){
    if(!showInvoiceTotalFilter()){
        return fields.filter(function (val){return !(["min_invoiceTotal","max_invoiceTotal"].includes(val.accessor))})
    }
    else
        return fields;
}

export function getDocumentFields(docType) {
    if(["invoice","archiveInvoice","sgkInvoice"].includes(docType)){
        return [
            {
                label: "Fatura No",
                accessor: "documentId",
                type: "text",
                operator: "=",
            },
            {
                label: "Fatura ETTN",
                accessor: "documentUuid",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı Unvan",
                accessor: "destinationTitle",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı VKN/TCKN",
                accessor: "destinationId",
                type: "numericText",
                operator: "=",
            },
            {
                label: "Alınma Tarihi (Başlangıç)",
                accessor: "min_receivedDate", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "datetime",
                operator: ">=",
            },
            {
                label: "Alınma Tarihi (Bitiş)",
                accessor: "max_receivedDate",
                type: "datetime",
                operator: "<=",
            },
            {
                label: "Fatura Tarihi (Başlangıç)",
                accessor: "min_documentIssueDate",
                type: "date",
                operator: ">=",
            },
            {
                label: "Fatura Tarihi (Bitiş)",
                accessor: "max_documentIssueDate",
                type: "date",
                operator: "<=",
            },
            {
                label: "Senaryo Türü",
                accessor: "documentProfile",
                type: "select",
                operator: "=",
                selectData: invoiceProfileTypesSelectData()
            },
            {
                label: "Fatura Türü",
                accessor: "invoiceTypeCode",
                type: "select",
                operator: "=",
                selectData: invoiceTypesSelectData()
            }
        ]
    }
    else if(docType === "despatch"){
        return [
            {
                label: "İrsaliye No",
                accessor: "documentId",
                type: "text",
                operator: "=",
            },
            {
                label: "İrsaliye ETTN",
                accessor: "documentUuid",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı Unvan",
                accessor: "destinationTitle",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı VKN/TCKN",
                accessor: "destinationId",
                type: "numericText",
                operator: "=",
            },
            {
                label: "Alınma Tarihi (Başlangıç)",
                accessor: "min_receivedDate", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "datetime",
                operator: ">=",
            },
            {
                label: "Alınma Tarihi (Bitiş)",
                accessor: "max_receivedDate",
                type: "datetime",
                operator: "<=",
            },
            {
                label: "İrsaliye Tarihi (Başlangıç)",
                accessor: "min_documentIssueDate",
                type: "date",
                operator: ">=",
            },
            {
                label: "İrsaliye Tarihi (Bitiş)",
                accessor: "max_documentIssueDate",
                type: "date",
                operator: "<=",
            },
            {
                label: "Senaryo Türü",
                accessor: "despatchTypeCode",
                type: "select",
                operator: "=",
                selectData: despatchProfileTypesSelectData()
            },
            {
                label: "İrsaliye Türü",
                accessor: "documentProfile",
                type: "select",
                operator: "=",
                selectData: despatchTypesSelectData()
            }
        ];
    }
    else if(["mm", "smm"].includes(docType)){
        return [
            {
                label: "Makbuz No",
                accessor: "documentId",
                type: "text",
                operator: "=",
            },
            {
                label: "Makbuz ETTN",
                accessor: "documentUuid",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı Unvan",
                accessor: "destinationTitle",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı VKN/TCKN",
                accessor: "destinationId",
                type: "numericText",
                operator: "=",
            },
            {
                label: "Alınma Tarihi (Başlangıç)",
                accessor: "min_receivedDate",
                type: "datetime",
                operator: ">=",
            },
            {
                label: "Alınma Tarihi (Bitiş)",
                accessor: "max_receivedDate",
                type: "datetime",
                operator: "<=",
            },
            {
                label: "Makbuz Tarihi (Başlangıç)",
                accessor: "min_documentIssueDate",
                type: "date",
                operator: ">=",
            },
            {
                label: "Makbuz Tarihi (Bitiş)",
                accessor: "max_documentIssueDate",
                type: "date",
                operator: "<=",
            },
            {
                label: "İptal Durumu",
                accessor: "cancelled",
                type: "select",
                operator: "=",
                selectData: [
                    {value: null, label: "Tümü"},
                    {value: "0", label: "İptal Edilmeyenler"},
                    {value: "1", label: "İptal Edilenler"},
                ]
            }

        ]
    }
    else if(["edefter-bildirim"].includes(docType)){
        return [
            {
                label: "Yıl",
                accessor: "year",
                type: "numericText",
                operator: "="
            },
            {
                label: "Ay",
                accessor: "month",
                type: "select",
                operator: "=",
                selectData: [
                    {value: null, label: "Tümü"},
                    {value: "1", label: 'Ocak'},
                    {value: "2", label: 'Şubat'},
                    {value: "3", label: 'Mart'},
                    {value: "4", label: 'Nisan'},
                    {value: "5", label: 'Mayıs'},
                    {value: "6", label: 'Haziran'},
                    {value: "7", label: 'Temmuz'},
                    {value: "8", label: 'Ağustos'},
                    {value: "9", label: 'Eylül'},
                    {value: "10", label: 'Ekim'},
                    {value: "11", label: 'Kasım'},
                    {value: "12", label: 'Aralık'}
                ]
            },
            {
                label: "VKN/TCKN",
                accessor: "customer_vknTckn",
                type: "numericText",
                operator: "=",
            }
        ];
    }
    else if(["edefter"].includes(docType)){
        return [
            {
                label: "Dönem",
                accessor: "min_startDate",
                type: "month",
                operator: ">=",
            },
            {
                label: "VKN/TCKN",
                accessor: "customer_vknTckn",
                type: "numericText",
                operator: "=",
            }
        ];
    }
}

export async function getUtsAuth() {
    let params = {
        url: `/uts/auth/getUtsAuth`,
        method: 'get'
    };
    return request(params)
        .then(function (response) {
            return Promise.resolve(response.data);
        }).catch(function (error) {
        showAxiosError(error);
    });
}

export function isLastDayOfMonth(year, month, day) {
    return new Date(year, month, 0).getDate() === day;
}

export function objectionTypes() {
    return [
        {
            label: "Kep",
            value: "KEP"
        },
        {
            label: "Noter",
            value: "NOTER"
        },
        {
            label: "Telgraf",
            value: "TELGRAF"
        },
        {
            label: "Taahhütlü Mektup",
            value: "TAAHHUTLU_MEKTUP"
        },
    ];
}

export async function fetchAllUserList() {
    let items = [];
    let params = {
        url: `/user/getUsername`,
        method: 'get'
    };
    return await request(params)
        .then(function (response) {
            response.data.map((item) => {
                items.push({
                    value: item, label: item
                })
            })
            return items;
        }).catch(function (error) {
            showAxiosError(error);
        });
}

export async function fetchAllRecordIdList() {
    let items = [];
    let params = {
        url: `/user/findAllUsernameAndRecordId`,
        method: 'get'
    };
    return await request(params)
        .then(function (response) {
            response.data.map((item) => {
                items.push({
                    value: item.recordId, label: item.userName
                })
            })
            return items;
        }).catch(function (error) {
            showAxiosError(error);
        });
}

export function turkishToLower(str) {
    let letters = {"İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç"};
    str = str.replace(/(([İIŞĞÜÇÖ]))/g, function (letter) {
        return letters[letter];
    })
    return str.toLowerCase();
}

export function getSelectedObjectsFromFieldValues(selected, fieldName) {
    let fieldValues = [];
    selected.map(s => {
        fieldValues.push(s[fieldName]);
    });
    return fieldValues;
}

export function decideBankType(type) {
    if (CustomerBankType.SGK === type) {
        return "SGK";
    } else if (CustomerBankType.KAMU === type) {
        return "KAMU";
    } else if (CustomerBankType.OTHER === type) {
        return "DİĞER";
    } else {
        return "";
    }
}

export function checkUserErpAndConnector(identifier,user,erpName){
    if (showConnector(EntegratorConf.identifier) &&
        hasUserRight(UserRightsEnum.ekonnektor.view, user) &&
        (erpName?.includes("MIKRO") || erpName?.includes("WIN") ) &&
        (isSularSaglikHizmetleri(user.vknTckn) || isVega(user.vknTckn))) {
        return true;
    } else {
        return false
    }
}

export function checkUserErpAndConnectorAndFis(identifier,erpName){
   return showConnector(EntegratorConf.identifier) && erpName?.includes("ZIRVE");
}

export function isSularSaglikHizmetleri(vknTckn) {
    return EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier && ("1960733903" === vknTckn);
}

export function isVega(vknTckn) {
    return EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier && ("8760557738" === vknTckn);
}

export function checkUseTmpUpdateQuery(vknTckn) {
    let vknList = [
        "4630070380",
        "5580704913",
        "4830564611",
        "4490487238",
        "4390358469",
        "2230961401",
        "3320402314",
        "7331005169"];
    return vknList.includes(vknTckn);
}

export function checkUseTmpUpdateQueryWithDespatch(vknTckn) {
    let vknList = [
        "2230961401"
    ];
    return vknList.includes(vknTckn);
}

export function enumToSelectData(enumData, hasEmptyOption) {
    let selectData = [];

    if (hasEmptyOption) {
        selectData.push({label: "", value: ""});
    }

    Object.keys(enumData).map(e => {
        selectData.push({label: enumData[e].label, value: enumData[e].value});
    });

    return selectData;
}